<div class="modal-body px-0">
	<div class="modal-header pr-4 pt-0">
		<h4 class="modal-title d-flex align-items-center justify-content-center">
			<label class="lbl-md pl-3 mb-0">{{ dailogTitle }}</label>
		</h4>
		<button
			type="button"
			class="btn-close close pull-right"
			[attr.aria-label]="page?.close"
			(click)="decline()"
		>
			<span aria-hidden="true" class="visually-hidden">&times;</span>
		</button>
	</div>
	<div class="col-12 mt-2 px-4 wrapper">
		<div class="main-container p-0">
			<ng-stepper
				#cdkStepper
				[linear]="true"
				class="pl-0"
				(selectionChange)="onStepChanged($event)"
			>
				<cdk-step [stepControl]="stepOne.form" [optional]="false">
					<ng-template cdkStepLabel>
						<div
							class="align-items-center justify-content-center d-flex flex-column position-relative"
						>
							<div class="step-bullet"></div>
							<div class="step-title">{{ page?.title }}</div>
						</div>
						<div class="bs-stepper-line"></div>
					</ng-template>
					<app-step-one #stepOne></app-step-one>
				</cdk-step>

				<cdk-step [stepControl]="stepTwo.stepTwoForm" [optional]="true">
					<ng-template cdkStepLabel>
						<div
							class="align-items-center justify-content-center d-flex flex-column"
						>
							<div class="step-bullet"></div>
							<div class="step-title">
								{{ page?.addMembers }} <small>{{ page?.optional }}</small>
							</div>
						</div>
						<div class="bs-stepper-line"></div>
					</ng-template>
					<app-step-two #stepTwo [stepNext]="isStepTwo"></app-step-two>
				</cdk-step>

				<cdk-step [stepControl]="stepThree.stepThreeForm" [optional]="false">
					<ng-template cdkStepLabel>
						<div class="step-bullet"></div>
						<div class="step-title">
							{{ page?.assignRoles }}<small>{{ page?.optional }}</small>
						</div>
					</ng-template>
					<app-step-three
						#stepThree
						[stepNext]="isStepTwo"
						(onSubmit)="onModelClose($event)"
					></app-step-three>
				</cdk-step>
			</ng-stepper>
		</div>
	</div>
</div>
